<template>
  <div class="header mt-3 mt-md-0">
    <div class="header-body">
      <div class="row align-items-center">
        <div class="col">
          <h6 class="header-pretitle">
            공지
          </h6>
          <h1 class="header-title">
            공지 게시물
          </h1>
          <div class="header-date">
            {{ date }}
          </div>
        </div>
        <div class="col-auto">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
	name: "NoticeHeader",
	props: ["date"],
};
</script>

<style lang="scss">
.header-date {
	margin-top: 13px;
	font-size: 13px;
	letter-spacing: -0.8px;
	color: #9b9b9b;
}
</style>
